import type { Result } from '$lib/result';
import type { JobsSearchIndex } from './JobsSearchIndex';

export enum BusinessUnit {
  BLOCK = 'block',
  SQUARE = 'square',
  CASHAPP = 'cashapp',
  SPIRAL = 'spiral',
  AFTERPAY = 'afterpay',
  TIDAL = 'tidal',
  BITKEY = 'bitkey',
  PROTO = 'proto'
}

export type Job = {
  id: number;
  internalId: number;
  requisitionId: string;
  title: string;
  bu: BusinessUnit;
  content: string;
  isRemote: boolean;
  jobFunction: string;
  location: string;
  employeeType: string | null;
};

export type JobsState = {
  jobs: Job[];
  searchIndex: JobsSearchIndex;
};

export type JobDetails = Job & {
  publicationDate: string;
};

export interface JobMapper<T> {
  from(data: T): Result<Job, string[]>;
}

export enum JobFilterName {
  TEAMS = 'teams',
  LOCATIONS = 'locations',
  EMPLOYEE_TYPES = 'employeeTypes',
  BUSINESS_UNITS = 'businessUnits'
}

export type JobFilters = {
  [key in JobFilterName]: string[];
};
